// Classe per mappare i ReturnCodes tornati dal backend.
// La convenzione prevede di non confrontare direttamente l'intero
// ma utilizzare i valori contenuti in questa classe che mappano uno a uno tali ReturnCodes
// in modo da poterli facilmente trovare e modificare  in caso di modifiche.
// Aggiungerli in caso di necessita. qui mettiamo solo quelli che usiamo.
// Cosciente che questa convenzione non ripara al 100% da eventuali errori.
export class ReturnCodes {
    static OK = 0;
    static UserMustChangePasswordError_19 = 19;
    static Error_27 = 27;
    static ExceptionOccurred_32 = 32;
    static InvalidUserError_56 = 56;
    static NoInstancesAvailable_74 = 74;
    static NoSubscriptionDatabasesAvailable_80 = 80;
    static DbUnderMaintenance_101 = 101;
}
